import { render, staticRenderFns } from "./ConfirmationTypeInfo.vue?vue&type=template&id=c4cb8b8c&scoped=true&"
import script from "./ConfirmationTypeInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeInfo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeInfo.vue?vue&type=style&index=0&id=c4cb8b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cb8b8c",
  null
  
)

export default component.exports